import { render, staticRenderFns } from "./u-crumb.vue?vue&type=template&id=fa766d68&"
import script from "./u-crumb.vue?vue&type=script&lang=js&"
export * from "./u-crumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports